export interface PricingTier {
  name: string
  price: string
  period: string
  description: string
  features: string[]
  highlighted?: boolean
}

export type HesapAilesi = 'MUSAVIR' | 'SIRKET'

/**
 * Fiyat ve kotalar backend paket kataloğundan (tenants) alınmıştır. Anonim ziyaretçi
 * `/paketlerim/` ucunu çağıramadığı için burada sabit metindir; kesin liste hesap
 * açıldıktan sonra Paketim ekranında görünür.
 *
 * Şirket ailesinin kota/modül kırılımı backend dokümanında paylaşılmadığından o iki
 * kart ad + fiyat + genel açıklama ile sınırlı tutuldu.
 */
export const pricingTiersByAile: Record<HesapAilesi, PricingTier[]> = {
  MUSAVIR: [
    {
      name: 'Başlangıç',
      price: '₺5.000',
      period: '/ay',
      description: 'Küçük ve orta ölçekli mali müşavirlik ofisleri için',
      features: [
        '50 müşteriye kadar',
        '25 bilanço müşterisi',
        '2 kullanıcı',
        'e-Fatura, e-Defter ve e-Envanter',
        'Genel muhasebe: yevmiye, mizan, mali tablolar',
      ],
    },
    {
      name: 'Profesyonel',
      price: '₺10.000',
      period: '/ay',
      description: 'Büyüyen ofisler ve ekipler için en popüler paket',
      features: [
        '100 müşteriye kadar',
        '50 bilanço müşterisi',
        '5 kullanıcı',
        'Başlangıç paketindeki her şey',
        'Banka mutabakatı, Z raporu ve ÖKC okutma',
        'İK modülü: bordro, puantaj, SGK bildirgeleri',
      ],
      highlighted: true,
    },
    {
      name: 'Kurumsal Gold',
      price: 'Özel fiyat',
      period: '',
      description: 'Büyük ölçekli operasyonlar için özelleştirilebilir çözüm',
      features: [
        'Sınırsız müşteri ve kullanıcı',
        '150 bilanço müşterisi',
        'Profesyonel paketindeki her şey',
        'Özel raporlar',
        'Kişisel hesap yöneticisi ve öncelikli destek',
      ],
    },
  ],
  SIRKET: [
    {
      name: 'İşletme',
      price: '₺3.000',
      period: '/ay',
      description: 'Kendi muhasebesini yöneten tek şirket için',
      features: [
        '1 şirket',
        '1 kullanıcı',
        'e-Fatura ve Z raporu',
        'KDV ve muhtasar beyannameleri',
      ],
    },
    {
      name: 'Şirketler',
      price: '₺5.000',
      period: '/ay',
      description: 'Genel muhasebe ve e-Defter ihtiyacı olan şirketler için',
      features: [
        '1 şirket',
        '4 kullanıcı',
        'İşletme paketindeki her şey',
        'e-Defter, e-Envanter ve envanter',
        'Banka mutabakatı',
      ],
      highlighted: true,
    },
  ],
}

export const aileLabels: Record<HesapAilesi, string> = {
  MUSAVIR: 'Mali Müşavir',
  SIRKET: 'Şirket',
}
